import {OBJECTIVES_REQUEST, OBJECTIVES_SHOW, OBJECTIVES_EDIT, OBJECTIVES_CLEAR, OBJECTIVES_FAIL} from "../store/config";

const objectivesInit = {
	isFetching: false,
	list: [],
	pages: {
		current: undefined,
		per_page: undefined,
		total: undefined
	},
	filters: {
		q:''
	},
	edit: {},
	permissions: [],
	error: undefined
}

const objectives = (state = objectivesInit, action) => {
	switch (action.type) {
		case OBJECTIVES_REQUEST:
			return {
				...state,
				isFetching: action.isFetching,
				timestamp: action.timestamp
			}
		case OBJECTIVES_SHOW:
			return {
				...state,
				isFetching: action.isFetching,
				list: action.payload,
				pages: action.pages,
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case OBJECTIVES_EDIT:
			return {
				...state,
				isFetching: action.isFetching,
				edit: action.payload,
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case OBJECTIVES_CLEAR:
			return {
				...state,
				edit: action.payload,
				timestamp: action.timestamp
			}
		case OBJECTIVES_FAIL:
			return {
				...state,
				isFetching: action.isFetching,
				error: action.error,
				timestamp: action.timestamp
			}
		default:
			return{
				...state
			}
	}
}

export default objectives;


// WEBPACK FOOTER //
// ./src/reducers/objectives.js